document.querySelectorAll('.collection-nav__item').forEach(e => {
    if (e.classList.contains('active')) {
        // console.log(e);

        // Find the scrollable parent
        const scrollContainer = document.querySelector('.collection-nav__list');

        if (scrollContainer) {
            // Calculate the position of the active element
            const elementOffset = e.offsetLeft;
            const elementWidth = e.offsetWidth;
            const containerWidth = scrollContainer.clientWidth;

            // Scroll to center the active element
            scrollContainer.scrollTo({
                left: elementOffset - (containerWidth / 2) + (elementWidth / 2),
                behavior: 'smooth' // Smooth scrolling animation
            });
        }
    }
});